import React from 'react'
import GAEventContextManager from 'shared/components/context/ga-event-manager'
import ModalContextManager from 'shared/components/context/modal-manager'
import ReduxBridgeManager from 'shared/components/context/redux-bridge-manager'
import RefreshDataContextManager from 'shared/components/context/refresh-data-manager'
import EditAPIContextManager from './components/context/edit-api-manager'
import VideoLoopManager from './components/context/video-loop-manager'
import VideoInlinePlayManager from './components/context/video-inline-play-manager'
import VideoMainManager from './components/context/video-main-manager'
import { FlashMessagesProvider } from './components/flash-message/flash-message'

const ContextManagers = ({ children }) => (
    <ReduxBridgeManager>
        <GAEventContextManager>
            <VideoLoopManager>
                <VideoInlinePlayManager>
                    <VideoMainManager>
                        <RefreshDataContextManager>
                            <EditAPIContextManager>
                                <ModalContextManager>
                                    <FlashMessagesProvider>
                                        {children}
                                    </FlashMessagesProvider>
                                </ModalContextManager>
                            </EditAPIContextManager>
                        </RefreshDataContextManager>
                    </VideoMainManager>
                </VideoInlinePlayManager>
            </VideoLoopManager>
        </GAEventContextManager>
    </ReduxBridgeManager>
)

export default ContextManagers
